import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '../views/LoginView.vue'
import ResetView from '../views/ResetView.vue'
import ForgetView from '../views/ForgetView.vue'
import EntryView from '../views/EntryView.vue'
import NotificationView from '../views/NotificationView.vue'
import ProfileView from '../views/ProfileView.vue'
import AnnouncementView from '../views/AnnouncementView.vue'

const base = "/"
const routes = [
  {
    path: base+'login',
    name: 'login',
    component: LoginView
  },
  {
    path: base+'reset-password',
    name: 'reset',
    component: ResetView
  },
  {
    path: base+'forget',
    name: 'forget',
    component: ForgetView
  },
  {
    path: base,
    name: 'entry',
    component: EntryView
  },
  {
    path: base+'notification',
    name: 'notification',
    component: NotificationView
  },
  {
    path: base+'profile',
    name: 'profile',
    component: ProfileView
  },
  {
  path: base+'announcement',
    name: 'announcement',
    component: AnnouncementView
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  if (( to.name !== 'login'  &&
        to.name !== 'reset' &&
        to.name !== 'forget')
      && !localStorage.jwt ){
    next({
      path: 'login',
      replace: true
    })
  } else {
    next();
  }
})

export default router
